import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import FreightOrderList from './views/FreightOrderList.vue';
import FreightOrder from './views/FreightOrder.vue';
import ContainerList from './views/ContainerList.vue';
import Container from './views/Container.vue';
import Monitoring from './views/Monitoring.vue';
import TerminalUtro from './views/TerminalUtro.vue';
import SignIn from './views/SignIn.vue';
import SignUp from './views/SignUp.vue';
import Profile from './views/Profile.vue';
import CompanyList from './views/CompanyList.vue';
import Company from './views/Company.vue';
import CompanyServices from './views/CompanyServices.vue';
import UserList from './views/UserList.vue';
import ExportTasks from './views/ExportTasks.vue';
import Transport from './views/Transport.vue';
import Services from './views/Services.vue';
import TrackingMonitoring from '@/views/TrackingMonitoring';
import TrackingAddContainer from '@/views/TrackingAddContainer';
import TrackingContainer from '@/views/TrackingContainer';

Vue.use(Router);

const redirectToSignInPageIfNotAuthorized = (to, from, next) => {
  if (!store.state.isAuthorized) {
    next(`/sign-in?from=${to.path}`);
    return;
  }

  if (to.meta.limitedAccess && !store.state.user.is_manager) {
    next('/');
    return;
  }

  next();
};

const redirectToHomePageIfAuthorized = (to, from, next) => {
  if (store.state.isAuthorized) {
    next('/');
    return;
  }
  next();
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.name !== from.name) {
      return { y: 0 };
    }
  },
  routes: [
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: redirectToHomePageIfAuthorized,
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp,
      beforeEnter: redirectToHomePageIfAuthorized,
    },
    {
      path: '/freight-orders',
      name: 'FreightOrderList',
      component: FreightOrderList,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/freight-orders/:id',
      name: 'FreightOrder',
      component: FreightOrder,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
    },
    {
      path: '/add-freight-order',
      name: 'AddFreightOrder',
      component: FreightOrder,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
    },
    {
      path: '/containers',
      name: 'ContainerList',
      component: ContainerList,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/containers/:id',
      name: 'Container',
      component: Container,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
    },
    {
      path: '/monitoring',
      name: 'Monitoring',
      component: Monitoring,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/reports/terminal-utro',
      name: 'TerminalUtro',
      component: TerminalUtro,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/add-container',
      name: 'AddContainer',
      component: Container,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/companies',
      name: 'CompanyList',
      component: CompanyList,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      meta: {
        limitedAccess: true,
      },
    },
    {
      path: '/company/:formType/:id?',
      name: 'Company',
      component: Company,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
      meta: {
        limitedAccess: true,
      },
    },
    {
      path: '/company-services/:companyId',
      name: 'CompanyServices',
      component: CompanyServices,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
      meta: {
        limitedAccess: true,
      },
    },
    {
      path: '/profiles',
      name: 'UserList',
      component: UserList,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      meta: {
        limitedAccess: true,
      },
    },
    {
      path: '/export-tasks',
      name: 'ExportTasks',
      component: ExportTasks,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/transport',
      name: 'Transport',
      component: Transport,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/tracking/monitoring',
      name: 'TrackingMonitoring',
      component: TrackingMonitoring,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      meta: { title: 'Tracking' },
    },
    {
      path: '/tracking/add-containers',
      name: 'TrackingAddContainer',
      component: TrackingAddContainer,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
    },
    {
      path: '/tracking/container/:id',
      name: 'TrackingContainer',
      component: TrackingContainer,
      beforeEnter: redirectToSignInPageIfNotAuthorized,
      props: true,
      meta: { title: 'Container' },
    },

    {
      path: '*',
      redirect: '/freight-orders',
    },
  ],
});
